import { render } from "./ContaContabilReferenciadaIndex.vue?vue&type=template&id=1014f55b&ts=true"
import script from "./ContaContabilReferenciadaIndex.vue?vue&type=script&lang=ts"
export * from "./ContaContabilReferenciadaIndex.vue?vue&type=script&lang=ts"

import exportComponent from "D:\\Desenvolvimento\\NeoXApp\\NeoX.Frontend\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__